var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.3289C27.665 35.3289 35.5 27.4938 35.5 17.8289C35.5 8.16387 27.665 0.328857 18 0.328857C8.33502 0.328857 0.5 8.16387 0.5 17.8289C0.5 27.4938 8.33502 35.3289 18 35.3289Z",
    fill: "#37BBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7332 10.5896C26.889 9.58276 25.9317 8.78805 25.0365 9.18111L7.20602 17.0096C6.56403 17.2915 6.611 18.264 7.27683 18.476L10.9539 19.647C11.6557 19.8705 12.4156 19.7549 13.0285 19.3315L21.3187 13.604C21.5687 13.4312 21.8412 13.7867 21.6276 14.0069L15.6601 20.1594C15.0812 20.7562 15.1961 21.7676 15.8925 22.2042L22.5737 26.394C23.3231 26.8639 24.2871 26.3919 24.4272 25.4862L26.7332 10.5896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8491c52317c0b97b3d5ce2ecb09b78c7.svg";
export { ForwardRef as ReactComponent };